import { ContactDetailsWrapper } from '../../../../../../Components/City/Form/Ambassador/ContactDetailsWrapper'
import { Col, Row } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import React, { useMemo } from 'react'

import { Input } from 'Components/Form/Input'
import { Dropzone } from 'Components/Form/Dropzone'
import SubmitButton from 'Components/Form/SubmitButton'
import { SelectDashboard } from 'Components/Form/SelectDashboard'
import { SubmitButtonBlock } from 'Components/Form/SubmitButton/SubmitButtonBlock'
import { validateBusinessNumber } from 'Utils/Validators/formValidation'
import { businessNumberTitle } from '../../../../../Form/City/Ambassador/ContactDetails'
import { getContractorTypesOptionsByCountryCode } from '../../../../../../Utils/Misc'
import { COUNTRY_CODE } from '../../../../../../constants'

const ContactForm = props => {
  const {
    spy,
    citiesOptions,
    handleSubmit,
    countryCode,
    canShowContractorType,
  } = props

  const validateBusinessNumberHandler = useMemo(
    () => validateBusinessNumber(countryCode),
    [countryCode],
  )

  return (
    <form>
      <ContactDetailsWrapper>
        <Col xs={2}>
          <Col xs={3}>
            <Field
              component={Dropzone}
              name="profilePicture"
              src={spy.profilePicture}
              cypress_id={'editSpyPageAvatar'}
            />
          </Col>
        </Col>
        <Col xs={10}>
          <Row>
            <Col xs={3}>
              <p className="col-title" cypress_id={'editSpyPageEmailTitle'}>
                Email Address
              </p>
              <p className="email" cypress_id={'editSpyPageEmailField'}>
                {spy.email}
              </p>
            </Col>
            <Col xs={3}>
              <p className="col-title" cypress_id={'editSpyPageFirstNameTitle'}>
                First Name
              </p>
              <Field
                name="firstName"
                id="firstName"
                component={Input}
                cypress_id={'editSpyPageFirstNameInput'}
              />
            </Col>
            <Col xs={3}>
              <p className="col-title" cypress_id={'editSpyPageLastNameTitle'}>
                Last Name
              </p>
              <Field
                name="lastName"
                id="lastname"
                component={Input}
                cypress_id={'editSpyPageLastNameInput'}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <p
                className="col-title"
                cypress_id={'editSpyPagePhoneNumberTitle'}
              >
                Phone number
              </p>
              <Field
                component={Input}
                name="mobilePhone"
                id="mobilePhone"
                cypress_id={'editSpyPageMobilePhoneInput'}
              />
            </Col>
            {countryCode !== COUNTRY_CODE.UNITED_STATES && (
              <Col xs={3}>
                <p
                  className="col-title"
                  cypress_id={'editSpyPageBusinessNumberTitle'}
                >
                  {businessNumberTitle(countryCode)}--
                </p>
                <Field
                  component={Input}
                  name="abn"
                  id="abn"
                  validate={validateBusinessNumberHandler}
                  cypress_id={'editSpyPageBusinessNumberInput'}
                />
              </Col>
            )}
          </Row>
          <Row>
            <Col xs={3}>
              <p className="col-title" cypress_id={'editSpyCityTitle'}>
                City
              </p>
              <Field
                name="cityId"
                component={SelectDashboard}
                options={citiesOptions}
                props={{ sorted: true }}
                cypress_id={'editSpyPageCityNameDropdown'}
              />
            </Col>
            {canShowContractorType ? (
              <Col xs={3}>
                <p className="col-title">Contractor type</p>
                <Field
                  name="contractorType"
                  component={SelectDashboard}
                  options={getContractorTypesOptionsByCountryCode(countryCode)}
                />
              </Col>
            ) : null}
          </Row>
        </Col>
      </ContactDetailsWrapper>
      <Row>
        <SubmitButtonBlock>
          <SubmitButton value="Save" onClick={handleSubmit} />
        </SubmitButtonBlock>
      </Row>
    </form>
  )
}

export default reduxForm({
  form: 'ambassador-contact-details-form',
  enableReinitialize: true,
})(ContactForm)
